<template>
  <ul id="item-list" class="item-list" :class="{ side: sidebar }">
    <li
      v-for="material in item.material"
      :key="material.name"
      :class="{ active: material.active }"
      @click="
        $emit(
          'onClickCombination',
          item.id,
          material.material_id,
          item.isMultiple,
          item.isOverlay
        )
      "
    >
      <template
        v-if="!item.isMultiple || (item.isMultiple && material.isDisabled)"
      >
        <img
          :src="material.name | getThumbnail(item.name, configuratorName)"
          alt="Material Thumbnail"
        />
        <span>{{ material.name | removeUnderscores }}</span>
        <br />
        <!-- <template v-if="configuratorName !== 'Chair'">
          <span v-if="material.name !== 'None'">£ {{ material.price }}</span>
        </template> -->
      </template>
    </li>
  </ul>
</template>

<script>
import { generate_map_link } from '@/lib/helpers';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

export default {
  name: 'Materials',
  props: {
    configuratorName: String,
    item: Object,
    sidebar: Boolean,
    disabled: Boolean,
  },
  filters: {
    removeUnderscores(text) {
      return text.replace(/_/gi, ' ');
    },
    getThumbnail(mat_name, mat_block, config_name) {
      return generate_map_link(config_name, mat_block, mat_name);
    },
  },
  data() {
    return {
      ps: null,
    };
  },
  mounted() {
    this.ps = new PerfectScrollbar('#item-list');
  },
  beforeDestroy() {
    this.ps.destroy();
    this.ps = null;
  },
  watch: {
    item() {
      document.querySelector('#item-list').scrollTop = 0;
    }
  }
};
</script>

<style></style>
